"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// this file is updated via the package prepare script
exports.version = '20.0.1';
//# sourceMappingURL=version.js.map